import { Charts } from './Charts';
import SectorizationChartsDataProvider from './contexts/SectorizationChartsDataContext';

const SectorizationWrapper = () => {
    return (
        <SectorizationChartsDataProvider>
            <Charts />
        </SectorizationChartsDataProvider>
    );
};

export default SectorizationWrapper;
